import styled from 'styled-components';

export const ExpiredLink = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	height: 100vh;
	background: #F3F3F3;
	flex-direction: row
`;

ExpiredLink.InfoContainer = styled.div`
	display: flex;
	width: 467px;
	margin-right: 120px;
	flex-direction: column;

	@media only screen and (max-width: 600px) {
		width: 400px !important;
		margin-right: 0 !important;
		padding: 20px
	}
`;

ExpiredLink.InfoTitle = styled.p`
	font-family: Inter;
	font-size: 32px;
	font-weight: 700;
	line-height: 40px;
	letter-spacing: 0em;
	text-align: left;
	margin-bottom: 40px !important;
	color: #005299;

	@media only screen and (max-width: 600px) {
		margin-bottom: 0 !important;
	}
`;

ExpiredLink.InfoText = styled.p`
	font-family: Inter;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0em;
	text-align: left;
`;

ExpiredLink.AmigoLogo = styled.img`
	text-align: left;
	width: 103.3px;
	height: 24px;
	margin-top: 85px;

	@media only screen and (max-width: 600px) {
		margin-top: 40px !important;
	}
`;

ExpiredLink.ExpiredLinWarningIcon = styled.img`
	width: 300px
	height: 300px
`;

